/* aly-fx.js · Local currency on the Alyviu Knee Strap product page (Munique Home).
   Display only. Shopify keeps charging in USD (no note on the page, by Rafael's decision on 19/oct/2026).
   Same idea as section 9 of adv.js on the advertorial, and the same sessionStorage keys
   (adv_country, adv_fx), so a lead coming from the advertorial sees the same rate instantly.

   - Skips when Shopify Markets already switched the storefront currency (prices are local then).
   - Country: window.Shopify.country (server side, from the visitor's IP) → cache → /browsing_context_suggestions.json.
   - Rate: open.er-api.com (daily), cached 12 h.
   - Converts every "$12.34" text inside #MainContent and the cart drawer, plus the data-price /
     data-compare / data-cta attributes that alyviu.js copies into the price line on variant change.
   - Re-runs on DOM changes (variant switch, cart drawer re-render, sticky bar). Guards against
     converting the same amount twice: WeakSet of text nodes, data-usd-* on offers, and elements
     alyviu.js writes into are refreshed from the already-converted attributes instead of walked. */
(function () {
  if (window.__alyFx) return;
  window.__alyFx = true;
  var SHOP = 'USD';
  var cur = (window.Shopify && window.Shopify.currency) || {};
  if (cur.active && cur.active !== SHOP) return;

  var CC = {BR:'BRL',AR:'ARS',CL:'CLP',CO:'COP',MX:'MXN',PE:'PEN',UY:'UYU',PY:'PYG',BO:'BOB',VE:'VES',DO:'DOP',GT:'GTQ',CR:'CRC',HN:'HNL',NI:'NIO',JM:'JMD',TT:'TTD',BS:'BSD',BB:'BBD',BZ:'BZD',GY:'GYD',SR:'SRD',HT:'HTG',
    CA:'CAD',GB:'GBP',IE:'EUR',AT:'EUR',BE:'EUR',CY:'EUR',DE:'EUR',EE:'EUR',ES:'EUR',FI:'EUR',FR:'EUR',GR:'EUR',HR:'EUR',IT:'EUR',LT:'EUR',LU:'EUR',LV:'EUR',MT:'EUR',NL:'EUR',PT:'EUR',SI:'EUR',SK:'EUR',
    CH:'CHF',NO:'NOK',SE:'SEK',DK:'DKK',IS:'ISK',PL:'PLN',CZ:'CZK',HU:'HUF',RO:'RON',BG:'BGN',RS:'RSD',UA:'UAH',TR:'TRY',IL:'ILS',RU:'RUB',KZ:'KZT',GE:'GEL',AM:'AMD',AZ:'AZN',
    AE:'AED',SA:'SAR',KW:'KWD',QA:'QAR',BH:'BHD',OM:'OMR',JO:'JOD',LB:'LBP',IQ:'IQD',EG:'EGP',MA:'MAD',DZ:'DZD',TN:'TND',NG:'NGN',GH:'GHS',KE:'KES',ZA:'ZAR',TZ:'TZS',UG:'UGX',ET:'ETB',MU:'MUR',
    IN:'INR',PK:'PKR',BD:'BDT',LK:'LKR',NP:'NPR',MV:'MVR',CN:'CNY',HK:'HKD',MO:'MOP',TW:'TWD',JP:'JPY',KR:'KRW',SG:'SGD',MY:'MYR',TH:'THB',VN:'VND',ID:'IDR',PH:'PHP',BN:'BND',KH:'KHR',LA:'LAK',MM:'MMK',MN:'MNT',
    AU:'AUD',NZ:'NZD',FJ:'FJD',PG:'PGK'};

  /* "$29.90", "$1,000", "$ 49" — but not "R$ 160,00" / "US$29.90" (letter before the sign) and not
     an amount followed by more digits, a comma or ".digit" (already-converted local formats). */
  var RE = /(^|[^A-Za-z])\$[\s ]?(\d{1,3}(?:,\d{3})+|\d+)(\.\d{2})?(?![\d,]|\.\d)(?:[\s ]?USD\b)?/g;   // a trailing \" USD\" (cart drawer totals) goes away with the conversion
  var SKIP = '[data-aly-fx-skip],[data-aly-price],[data-aly-compare],[data-aly-cta],script,style,textarea';
  var state = { code: null, rate: 0, digits: 2 };
  var done = (typeof WeakSet === 'function') ? new WeakSet() : { has: function () { return false; }, add: function () {} };

  var fmt = function (amount) {
    try {
      return new Intl.NumberFormat(navigator.language || 'en', { style: 'currency', currency: state.code, minimumFractionDigits: state.digits, maximumFractionDigits: state.digits }).format(amount);
    } catch (e) { return state.code + ' ' + amount.toFixed(state.digits); }
  };
  var conv = function (text) {
    return text.replace(RE, function (m, pre, whole, dec) {
      var usd = parseFloat(whole.replace(/,/g, '') + (dec || ''));
      return usd > 0 ? pre + fmt(usd * state.rate) : m;
    });
  };
  var roots = function () {
    return [document.getElementById('MainContent') || document.querySelector('main'), document.querySelector('cart-drawer-component')].filter(Boolean);
  };
  var walk = function (root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, nodes = [];
    while ((n = walker.nextNode())) {
      if (n.nodeValue.indexOf('$') < 0 || done.has(n)) continue;
      var p = n.parentNode;
      if (p && p.nodeType === 1 && p.closest && p.closest(SKIP)) continue;
      nodes.push(n);
    }
    nodes.forEach(function (node) {
      done.add(node);
      var v = conv(node.nodeValue);
      if (v !== node.nodeValue) node.nodeValue = v;
    });
  };
  /* alyviu.js copies these attributes into the price line / button on every variant change. */
  var offersAttrs = function (root) {
    root.querySelectorAll('[data-aly-offer]').forEach(function (o) {
      ['price', 'compare', 'cta'].forEach(function (k) {
        var v = o.getAttribute('data-' + k);
        if (!v || v.indexOf('$') < 0 || o.hasAttribute('data-usd-' + k)) return;
        o.setAttribute('data-usd-' + k, v);
        o.setAttribute('data-' + k, conv(v));
      });
    });
  };
  var refreshSelected = function () {
    document.querySelectorAll('[data-aly-hero]').forEach(function (hero) {
      var checked = hero.querySelector('[data-aly-offer] input:checked');
      var o = checked && checked.closest('[data-aly-offer]');
      if (!o) return;
      var price = hero.querySelector('[data-aly-price]'), compare = hero.querySelector('[data-aly-compare]'), cta = hero.querySelector('[data-aly-cta]');
      if (price && o.getAttribute('data-price')) price.textContent = o.getAttribute('data-price');
      if (compare && o.getAttribute('data-compare')) compare.textContent = o.getAttribute('data-compare');
      if (cta && o.getAttribute('data-cta')) cta.textContent = o.getAttribute('data-cta');
    });
  };
  var pending = false;
  var run = function () {
    pending = false;
    roots().forEach(function (r) { offersAttrs(r); walk(r); });
    refreshSelected();
  };
  var schedule = function () {
    if (pending) return;
    pending = true;
    (window.requestAnimationFrame || setTimeout)(run);
  };

  var start = function (code, rate) {
    state.code = code; state.rate = rate;
    var base = Infinity;
    document.querySelectorAll('[data-aly-offer]').forEach(function (o) {
      var u = parseFloat(String(o.getAttribute('data-usd-price') || o.getAttribute('data-price') || '').replace(/[^\d.]/g, ''));
      if (u > 0 && u < base) base = u;
    });
    state.digits = (base !== Infinity && base * rate >= 50) ? 0 : 2;   // same number of decimals everywhere on the page
    run();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-aly-offer]')) schedule();
    });
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  };
  var withRate = function (code) {
    if (!code || code === SHOP) return;
    var c = null;
    try { c = JSON.parse(sessionStorage.getItem('adv_fx') || 'null'); } catch (e) {}
    if (c && c.cur === code && c.rate > 0 && Date.now() - c.ts < 12 * 3600 * 1000) { start(code, c.rate); return; }
    fetch('https://open.er-api.com/v6/latest/USD').then(function (r) { return r.json(); }).then(function (j) {
      var rate = j && j.rates && j.rates[code];
      if (!(rate > 0)) return;
      try { sessionStorage.setItem('adv_fx', JSON.stringify({ ts: Date.now(), cur: code, rate: rate })); } catch (e) {}
      start(code, rate);
    }).catch(function () {});
  };
  var byCountry = function (cc) { withRate(CC[String(cc || '').toUpperCase()]); };

  if (window.Shopify && window.Shopify.country) { byCountry(window.Shopify.country); return; }
  var cached = null;
  try { cached = JSON.parse(sessionStorage.getItem('adv_country') || 'null'); } catch (e) {}
  if (cached && cached.handle) { byCountry(cached.handle); return; }
  fetch('/browsing_context_suggestions.json', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (j) {
      var c = j && j.detected_values && j.detected_values.country;
      if (!c || !c.handle) return;
      try { sessionStorage.setItem('adv_country', JSON.stringify(c)); } catch (e) {}
      byCountry(c.handle);
    })
    .catch(function () {});
})();
